import Vue from 'vue'
import Router from 'vue-router'
import '@/store'
import Auth from './auth'
import Api from './api'
import Errors from './errors'
import Vuelidate from 'vuelidate'
import VueI18n from 'vue-i18n'
import VueResource from 'vue-resource'
import Toasted from 'vue-toasted'
import Table from '@/components/table'
import Crud from '@/components/crud'
import Breadcrumb from '@/components/breadcrumb'
import ManyToOne from '@/components/many-to-one'
import Duration from '@/components/duration'
import DateCustom from '@/components/date'
import HeadersDetail from '@/components/commun'
import Login from '@/components/login'

import Lang from '@/components/lang'

import Dropdown from '@/components/dropdown'

import EnumEnityField from '@/components/enumEntity'

import VuetifySettings from './stylus/vuetify'
import Vuetify from 'vuetify'
import vueDompurifyHTMLPlugin from 'vue-dompurify-html'

import VueTheMask from 'vue-the-mask'
import ICS from 'vue-ics'

import IdleVue from 'idle-vue'
import Adherent from '@/components/adherents'
import 'viewerjs/dist/viewer.css'
import VueViewer from 'v-viewer'

Vue.use(Auth)
Vue.use(Api)
Vue.use(Errors)
Vue.use(Table)
Vue.use(Crud)
Vue.use(Breadcrumb)
Vue.use(ManyToOne)
Vue.use(Duration)
Vue.use(DateCustom)
Vue.use(HeadersDetail)
Vue.use(Lang)
Vue.use(vueDompurifyHTMLPlugin)

Vue.use(Dropdown)

Vue.use(EnumEnityField)

Vue.use(Vuetify, VuetifySettings)
Vue.use(Router)
Vue.use(Vuelidate)
Vue.use(VueI18n)
Vue.use(VueResource)
Vue.use(Toasted, {
  duration: 4000,
})

Vue.use(VueTheMask)
var AddToCalendar = require('vue-add-to-calendar')
Vue.use(AddToCalendar)
Vue.use(ICS)
const eventsHub = new Vue()
Vue.use(IdleVue, {
  eventEmitter: eventsHub,
  idleTime: 300000,
})
Vue.use(Login)
Vue.use(Adherent)
Vue.use(VueViewer)
